import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextBox = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.25 9C2.25 3.75 3.75069 2.25 9.00034 2.25C14.25 2.25 15.75 3.75 15.75 9C15.75 14.25 14.1923 15.75 9.00034 15.75C3.80838 15.75 2.25 14.25 2.25 9Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.4 11.25C8.4 11.5814 8.66863 11.85 9 11.85C9.33137 11.85 9.6 11.5814 9.6 11.25H8.4ZM6.75 6.15C6.41863 6.15 6.15 6.41863 6.15 6.75C6.15 7.08137 6.41863 7.35 6.75 7.35V6.15ZM11.25 7.35C11.5814 7.35 11.85 7.08137 11.85 6.75C11.85 6.41863 11.5814 6.15 11.25 6.15V7.35ZM8.4 6.75V11.25H9.6V6.75H8.4ZM9 6.15H6.75V7.35H9V6.15ZM9 7.35H11.25V6.15H9V7.35Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgTextBox);
export { ForwardRef as ReactComponent };
